import { BaseService } from 'core/services';
import CorporateRouteService from './CorporateRouteService';

class CorporateService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CorporateRouteService());
    }

    getDownloadContactsUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadContacts(filter);
    }
}

export default CorporateService;
